import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LeedService } from 'src/app/service/leed.service';

@Component({
  selector: 'app-manager-leeds',
  templateUrl: './manager-leeds.component.html',
  styleUrls: ['./manager-leeds.component.css']
})
export class ManagerLeedsComponent implements OnInit {
  totalDistribuidores = 0;
  totalRegioes = 0;
  totalLeeds = 0;
  totalNovosLeeds = 0;
  carregando = true;

  constructor(private router: Router, private leedService: LeedService) { }

  ngOnInit() {
    this.carregarDashboard();
  }

  carregarDashboard() {
    this.carregando = true;
    this.leedService.getDashboard().subscribe((res: any) => {
      const item = res && res.item ? res.item : {};
      this.totalDistribuidores = item.totalDistribuidores || 0;
      this.totalRegioes = item.totalRegioes || 0;
      this.totalLeeds = item.totalLeeds || 0;
      this.totalNovosLeeds = item.totalNovosLeeds || 0;
      this.carregando = false;
    }, () => {
      this.carregando = false;
    });
  }

  cadRegiao() {
    this.router.navigate(['/regiao']);
  }

  cadDistribuidor() {
    this.router.navigate(['/distribuidor']);
  }

  gerenciamentoLeeds() {
    this.router.navigate(['/gerenciamento-leeds']);
  }

}
